import { cva } from "class-variance-authority";

export { default as File } from "./File.vue";

export const variants = cva(
    [
        "flex",
        "items-center",
        "justify-between",
        "shrink-0",
        "py-2",
        "px-3",
        "border-secondary",
        "transition-all",
        "duration-300",
    ],
    {
        variants: {
            color: {
                white: ["bg-primary"],
                gray: ["bg-secondary"],
                transparents: ["bg-transparent"],
            },
            size: {
                sm: ["rounded-sm"],
                md: ["rounded-md"],
                lg: ["rounded-xl"],
            },
            border: {
                true: "border",
                false: ["py-0", "px-0"],
            },
        },
        defaultVariants: {
            variant: "default",
            color: "white",
            size: "md",
            border: true,
        },
    }
);
